import React from 'react'
import Style from './ExploreSection.css'
import Button from '../Button'
import visit from '../../assets/visit.jpg'

const ExploreSection = (props) => {
  return (
    <section className={`explore-section ${props.show}`}>
      <div className="container">
        <h2>We’d Love To Meet You</h2>
      </div>
      <div className="container">
        <div className="intro-wrap flex-basis-full">
          <div className="pr-12">
            <p className="psuedo-before-color-arizona-red explore-heading">
              <b>
                The best way to learn about the exclusive privileges you’ll enjoy as a Franke Honors
                Wildcat? Experiencing them first-hand by planning a visit to campus.
              </b>
            </p>
            <p className="">
              We regularly offer Honors Information Sessions, which are a great opportunity to learn
              about Franke Honors courses, research and involvement opportunities, the Honors
              Village, and much more.
            </p>
            <p>
              Can’t make it to an Honors Information Session? We’d gladly arrange a personalized
              visit for you and your family. Contact us at{' '}
              <a
                id="honors@arizona.edu"
                className="font-color-arizona-blue font-normal"
                href="mailto:honors@arizona.edu"
                target="_blank"
              >
                honors@arizona.edu
              </a>{' '}
              or{' '}
              <a
                href="tel:+1520.621.6901"
                className="font-color-arizona-blue font-normal decoration-none"
                target="_blank"
              >
                520.621.6901
              </a>
              .
            </p>

            <div className="explore-button">
              <Button
                linkId="visit-us"
                link="https://frankehonors.arizona.edu/admissions/visit-us?_gl=1*n58fqp*_gcl_aw*R0NMLjE3MTgyMjM2MTMuQ2p3S0NBandqcVd6QmhBcUVpd0FRbXRnVF9GSUZaeHVldzRkQjcxVzZvQzNUWGlCZ0ZwdHRtZW9qY1NRWkJKS0FvZ29QZFJCWHB0MFdSb0MxWmNRQXZEX0J3RQ..*_gcl_au*MTAwODkwMDQ0LjE3MTY4MzM1NjE.*_ga*Mzc1NjE3MjA4LjE2OTU0MDk1NTA.*_ga_7PV3540XS3*MTcxOTg1MDk0My40NzYuMS4xNzE5ODUzNDU0LjAuMC4w
"
              >
                Visit Us
              </Button>
            </div>
          </div>
        </div>
        <div className="pl-12 explore-image">
          {' '}
          <img src={visit} alt="Students walking in front of W.A Franke building" />
        </div>
      </div>
    </section>
  )
}

export default ExploreSection
